import React from 'react';
import './PaymentSuccessModal.css'; 
import { useNavigate } from "react-router-dom";

const PaymentSuccessModal = ({ isOpen, onClose, message, status = 'success' }) => {
    const navigate = useNavigate();
    if (!isOpen) return null; // Don't render if not open
    const statusClass = status === 'SUCCESS' ? 'success-message' : 'error-message';

    const handleClose = () => {
        onClose(false)
        navigate("/")
        window.location.reload();
    }

    const message_heading = 
        status === "SUCCESS" ? "Registration successful" :
        status === "PENDING" ? "Registration pending" :
        status === "FAILURE" ? "Registration failed" :
        status === "FAILED" ? "Registration failed" :
        status === "PURCHASED" ? "Registration successful" :
        "FAILED";

        console.log(status,' status')

    return (
        <div className="payment-success-modal">
        <div className="modal-content">
            <h2 className={statusClass}>
                {message_heading}
            </h2>

            <p className="success-details">
            {message ? message : (
                status === 'SUCCESS' || status === 'PURCHASED' ?
                'Your payment has been processed successfully. Please check your email for confirmation and further instructions.' :
                'Registration Failed Kindly try again.'
            )}
            </p>
            

            <button className="close-button" onClick={handleClose}> Close</button>
        </div>
        </div>
    );
};

export default PaymentSuccessModal;
